import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { DescriptionMyGallery } from "./DescriptionMyGallery";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { GalleryGridWithDescriptionCap, GalleryGridWithDescriptions, GalleryTitle } from "../../../Constant";

const GalleryImageDescriptionContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={GalleryGridWithDescriptions} parent={GalleryTitle} title={GalleryGridWithDescriptions} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={GalleryGridWithDescriptionCap} />
              <CardBody className="my-gallery row gallery-with-description">
                <DescriptionMyGallery />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GalleryImageDescriptionContainer;
